import React, { FC, useContext, useRef, useState } from 'react';
import { Header, Icon, List, ListProps }           from 'semantic-ui-react';
import moment                                      from 'moment';
import classNames                                  from 'classnames';
import { Cell, Grid }                              from "styled-css-grid";
import _                                           from 'underscore';

import { SystemAccountingQueries }                            from '../../../../../queries';
import { CorvalProject, CorvalUIColor, CorvalUserLike, Size } from '../../../../../types';
import { TimeService, UserService }                           from '../../../../../services';
import { capitalize }                                         from '../../../../../util';
import { useCurrentUser }                                     from '../../../../../hooks';
import { StyledContainer }                                    from '../../../../containers';
import { OrganizationUser }                                   from '../../../../components/user/OrganizationUser';
import { LoadingIndicator }                                   from '../../../../components/util/loading/LoadingIndicator';
import { ListFromQuery }      from '../../../../components/from-query/ListFromQuery';
import { ProjectListContext } from './ProjectListIndexPage';
import { ProjectListItem }    from './ProjectListItem';

interface Props {}

const defaultProps: Props = {}

const ProjectList: FC<Props> = ( props ) => {
	
	let { currentUser }                                = useCurrentUser(),
	    { setFocusedProjectId, projectListRequestRef } = useContext( ProjectListContext );
	
	// Listing variables
	const projectListingQuery = SystemAccountingQueries.queries.GET_PROJECTS( `id organizationId name createdUtc createdById assetName updatedUtc updatedById` ),
	      projectListingVars  = {
		      where: {
			      id:       { in: _.pluck( currentUser.projects, 'projectId' ) },
			      isActive: { eq: true }
		      },
		      order: [
			      { updatedUtc: 'DESC', },
			      { name: 'ASC' }
		      ]
	      }
	
	return (
		
		<ListFromQuery
			innerRef={ projectListRequestRef }
			query={ projectListingQuery }
			queryOptions={ {
				variables:   projectListingVars,
				fetchPolicy: 'network-only'
			} }
			queryResultObject={ data => data.projects }
			containerComponent={ ( props: ListProps ) => {
				return <List divided relaxed inverted { ...props }/>
			} }
			itemComponent={ ( { item }: { item: Partial<CorvalProject> } ) => (
				
				<ProjectListItem item={ item } onClick={ () => setFocusedProjectId( item.id ) }/>
			
			) }
			loadingComponent={ () => (
				
				<div className={ 'margin-xl-top' }>
					<LoadingIndicator isActive={ true } dimmer={ false } inverted label={ 'Retrieving Project List...' }/>
				</div>
			
			) }
			noItemsComponent={ () => (
				
				<StyledContainer textColor={ CorvalUIColor.LT_SCREEN_50 }>You don't have any active projects.</StyledContainer>
			
			) }
		/>
	);
};

ProjectList.defaultProps = defaultProps;

export { ProjectList }
